import { CountryIso3166 } from "@tfg/db"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm.tsx"

const fields: FormFieldConfig[] = [
  {
    type: "text",
    name: "name",
    label: "Supplier Name",
    placeholder: "john Doe",
  },
  {
    type: "text",
    name: "email",
    label: "Supplier Email",
    placeholder: "example@gmail.com",
  },
  {
    type: "text",
    name: "company.name",
    label: "Company name",
    placeholder: "Google",
  },
  {
    type: "text",
    name: "company.street",
    label: "Street ",
    placeholder: "123 Fake Street",
  },
  {
    type: "text",
    name: "company.city",
    label: "City",
    placeholder: "Paris",
  },
  {
    type: "text",
    name: "company.postalCode",
    label: "Postal Code ",
    placeholder: "75001",
  },
  {
    type: "countrySelect",
    name: "company.country",
    label: "Company Country",
    placeholder: "FR",
    options: Object.values(CountryIso3166).map((value) => ({
      label: value,
      value,
    })),
  },
]

export { fields }
